<template>
  <div class="Icon"
    :style="{ width, height }">

    <svg class="Icon-svg"
      :style="{ fill }">
      <use :xlink:href="icon"></use>
    </svg>

  </div>
</template>

<script>
const ctx = require.context('icons', true, /\.svg$/)
const icons = {}

ctx.keys().forEach(key => {
  const name = key.replace('./', '').replace('.svg', '')
  icons[name] = ctx(key)
})

export default {
  props: {
    name: {
      description: 'The icon file name (minus extension).',
      type: String,
      required: true
    },
    width: {
      description: 'The width of the SVG icon.',
      type: String,
      default: '12px'
    },
    height: {
      description: 'The height of the SVG icon.',
      type: String,
      default: '12px'
    },
    fill: {
      description: 'Fill color for the SVG icon. Can be overridden in CSS with !important.',
      type: String,
      default: '#000'
    }
  },

  computed: {
    icon () {
      return icons[this.name]
    }
  }
}
</script>

<style>
@import 'properties';

.Icon {

}

.Icon-svg {
  display: block;
  max-width: 100%;
  max-height: 100%;
}
</style>



// WEBPACK FOOTER //
// Icon.vue?3ba2e9e5